const defaultNewTenantForm = {
    id: '',
    name: '',
    selling_companies: [],
    groups: [],
    signature: null,
    type: '',
    email: '',
}

export default defaultNewTenantForm;